<div class="bg-wrapper pt-2">
    <header class="mb-2 container">
        <span class="brand"
            ><img src="assets/images/jsw-logo.png" alt="jsw-logo"
        /></span>
    </header>

    <main class="container justify-content-center py-5">
        <div class="row">
            <div class="col-md-6">
                <div class="value-prop-pane pt-5">
                    <div
                        id="carouselSlides"
                        class="carousel slide"
                        data-bs-ride="carousel"
                    >
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <h2>WELCOME TO THE JSW VENDOR PORTAL</h2>
                                <p>
                                    Manage your daily interactions and
                                    collaborate with JSW in real time
                                </p>
                            </div>
                            <div class="carousel-item">
                                <h2>
                                    MAXIMIZE OPERATIONAL EFFICIENCY AND
                                    EFFECTIVENESS
                                </h2>
                                <ul>
                                    <li>
                                        Submit and automatically validate your
                                        invoices;
                                    </li>
                                    <li>
                                        Speed up the dispute management process.
                                    </li>
                                </ul>
                            </div>
                            <div class="carousel-item">
                                <h2>GAIN REAL-TIME BUSINESS INSIGHTS</h2>
                                <ul>
                                    <li>
                                        Track your invoices from submission to
                                        payment;
                                    </li>
                                    <li>
                                        Get quick access to all relevant
                                        information in one place.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="carousel-indicators">
                            <button
                                type="button"
                                data-bs-target="#carouselExampleCaptions"
                                data-bs-slide-to="0"
                                class="active"
                                aria-current="true"
                                aria-label="Slide 1"
                            ></button>
                            <button
                                type="button"
                                data-bs-target="#carouselExampleCaptions"
                                data-bs-slide-to="1"
                                aria-label="Slide 2"
                            ></button>
                            <button
                                type="button"
                                data-bs-target="#carouselExampleCaptions"
                                data-bs-slide-to="2"
                                aria-label="Slide 3"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-10 offset-md-2">
                        <div class="form-container">
                            <h3 class="mb-4">Get Started</h3>
                            <p class="mb-4">
                                Enter your vendor code and temporary password to
                                activate your account
                            </p>
                            <form
                                [formGroup]="vendor"
                                (ngSubmit)="onValidateVendor()"
                            >
                                <p *ngIf="isError" class="help-block">
                                    <span
                                        ><i class="ri-error-warning-fill"></i
                                    ></span>
                                    Sorry, incorrect Vendor Code or Password
                                </p>
                                <p *ngIf="isServerError" class="help-block">
                                    <span
                                        ><i class="ri-error-warning-fill"></i
                                    ></span>
                                    Sorry, your request could not be processed.
                                    Please contact JSW Admin
                                </p>
                                <div class="mb-4">
                                    <label class="form-label"
                                        >Vendor Code</label
                                    >
                                    <p
                                        class="help-block"
                                        *ngIf="
                                            !vendor.get('userName')?.valid &&
                                            vendor.get('userName')?.touched
                                        "
                                    >
                                        Vendor Code is required
                                    </p>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="vendor_code"
                                        placeholder="Eg. ALWPG5809L"
                                        formControlName="userName"
                                    />
                                </div>
                                <div class="mb-4">
                                    <label class="form-label">Password</label>
                                    <p
                                        class="help-block"
                                        *ngIf="
                    vendor.get('password')?.errors?.['required'] &&
                      vendor.get('password')?.touched
                    "
                                    >
                                        Password is required
                                    </p>
                                    <p
                                        class="help-block"
                                        *ngIf="
                    vendor.get('password')?.errors?.['minlength'] && vendor.get('password')?.touched
                    "
                                    >
                                        Password must be 10 characters and
                                        alphanumberic
                                    </p>
                                    <input
                                        type="password"
                                        class="form-control"
                                        id="activation_password"
                                        placeholder="Eg. 100XX622T0"
                                        formControlName="password"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    [disabled]="vendor.invalid"
                                    class="btn btn-primary"
                                >
                                    Get Started
                                </button>
                                <div
                                    class="loader text-center mt-3"
                                    *ngIf="isLoading"
                                >
                                    Loading ...
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <span class="brand-payex"
                ><img src="assets/images/payex-logo.png" alt="PayExLogo"
            /></span>
        </p>
    </footer>
</div>
